<template>
  <div class="home mt-2">
    <bread-crumbs :from="{name: 'Users', type: 'user',link:'users'}" :to="{name: 'About User'}"></bread-crumbs>
    <page-title
      :title="user.first_name + ' ' + user.last_name"
      :route="null"
      :description="'📨' + user.email"
    />
    <div>
      <a-row>
        <div style="padding-left:20px; padding-top:20px">
          <h6 class="text-opacity">QUICK NAVIGATION</h6>
        </div>
        <a-col :span="7">
          <a-menu style="width: 256px" :defaultSelectedKeys="['1']" mode="inline">
            <a-sub-menu class="account-nav--left" key="sub1">
              <span slot="title">
                <a-icon type="solution"/>
                <span>Basic Information</span>
              </span>
            </a-sub-menu>
            <a-sub-menu class="account-nav--left" key="sub2">
              <span slot="title">
                <a-icon type="compass"/>
                <span>Location Information</span>
              </span>
            </a-sub-menu>
            <a-sub-menu class="account-nav--left" key="sub4">
              <span slot="title">
                <a-icon type="idcard"/>
                <span>Access Controls (Roles)</span>
              </span>
              <a-menu-item key="9">Option 9</a-menu-item>
            </a-sub-menu>
          </a-menu>
        </a-col>
        <a-col :span="17">
          <a-card>
            <div>
              <router-link :to="{name: 'users-edit'}" style="color:black">
                <button class="btn-fixed">
                  <a-icon type="edit" class="pr-1" style="padding-right:3px"/>Edit User
                </button>
              </router-link>
            </div>
            <a-row>
              <a-col :span="24">
                <center>
                  <a-avatar :size="100" style="font-size:20px !important;background: #B4ABDC">U</a-avatar>
                  <span class="avatar--action">
                    <a-icon type="camera"/>
                  </span>
                </center>
              </a-col>

              <a-col class="mt-4 pl-2" :span="24">
                <a-row>
                  <a-col :span="24">
                    <span class="text-bold">BASIC INFORMATION</span>
                  </a-col>
                </a-row>
                <a-row class="mt-2">
                  <a-col class="font-x2" :span="12">
                    <small class="text-opacity">Full Name</small>
                    <p>{{user.first_name}} {{user.last_name}}</p>
                  </a-col>
                  <a-col class="font-x2" :span="12">
                    <small class="text-opacity">Email</small>
                    <p>{{user.email ? user.email : 'Not Available'}}</p>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col class="font-x2" :span="12">
                    <small class="text-opacity">Contact Phone</small>
                    <p>{{user.phone_number ? user.phone_number : 'Not Available'}}</p>
                  </a-col>
                  <a-col class="font-x2" :span="12">
                    <small class="text-opacity">Username</small>
                    <p>@{{user.username}}</p>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col class="font-x2" :span="12">
                    <small class="text-opacity">Fax</small>
                    <p>{{user.fax ? user.fax : 'Not Available'}}</p>
                  </a-col>
                </a-row>
              </a-col>

              <!-- Location -->
              <a-col class="mt-4 pl-2" :span="24">
                <a-row>
                  <a-col :span="24">
                    <span class="text-bold">LOCATION INFORMATION</span>
                  </a-col>
                </a-row>
                <a-row class="mt-2">
                  <a-col class="font-x2" :span="12">
                    <small class="text-opacity">Country</small>
                    <p>{{user.country ? user.country.name : 'Not Available'}}</p>
                  </a-col>
                  <a-col class="font-x2" :span="12">
                    <small class="text-opacity">State</small>
                    <p>{{user.state ? user.state.name : 'Not Available'}}</p>
                  </a-col>
                </a-row>
                <a-row>
                  <a-col class="font-x2" :span="12">
                    <small class="text-opacity">City</small>
                    <p>{{user.city ? user.city.name : 'Not Available'}}</p>
                  </a-col>
                  <a-col class="font-x2" :span="12">
                    <small class="text-opacity">Zip Code</small>
                    <p>{{user.zip_postal_code ? user.zip_postal_code : 'Not Available'}}</p>
                  </a-col>
                  <a-col class="font-x2" :span="24">
                    <small class="text-opacity">Address</small>
                    <p>{{user.street_address ? user.street_address : 'Not Available'}}</p>
                  </a-col>
                </a-row>
              </a-col>

              <!-- Roles and Permissions -->
              <a-col class="mt-4 pl-2" :span="24">
                <a-row>
                  <a-col :span="24">
                    <span class="text-bold">ROLES</span>
                  </a-col>
                </a-row>
                <a-row class="mt-2">
                  <a-col :span="24">
                    <a-tag v-if="user.role">{{user.role.name}}</a-tag>
                    <span v-else>Not Available</span>
                  </a-col>
                </a-row>
              </a-col>
            </a-row>
          </a-card>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
import PageTitle from "@/components/Headers/PageTitle";
import BreadCrumbs from "@/components/Headers/BreadCrumbs.vue";
export default {
  data() {
    return {
      user: {
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        username: "",
        fax: ""
      }
    };
  },
  components: { PageTitle, BreadCrumbs },
  methods: {
    fetchUser() {
      this.$store
        .dispatch("getUser", this.$route.params.id)
        .then(s => {
          this.user = s.data;
        })
        .catch(d => {
          this.$message.error("The User for that ID couldnt be found");
        });
    }
  },
  mounted() {
    this.fetchUser();
  }
};
</script>
